var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"no-margin-top":"","title":"Observações da pós-consulta"}},[_c('rkm-row',[_c('rkm-col',{attrs:{"cols":"12"}},[_c('Item',{attrs:{"get-value":() => _vm.item.observacoes}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }